import api from './api';

/**
 * COSCO On-Hire request lifecycle:
 *   created — INSERT row, extension hasn't reported submission yet
 *   submitted — Freshdesk redirected to /tickets/<id>; extension PUT'd
 *   completed — operator manually flipped (after COSCO email reply)
 *   abandoned — tab closed before redirect or operator gave up
 */
export type CoscoOnhireStatus = 'created' | 'submitted' | 'completed' | 'abandoned';

export interface CoscoOnhireRequest {
  id: number;
  company_id: number;
  task_id: number | null;
  container_number: string;
  destination_terminal: string | null;
  region: string;
  location: string;
  submitter_email: string;
  description_html: string | null;
  status: CoscoOnhireStatus;
  freshdesk_ticket_id: string | null;
  freshdesk_ticket_url: string | null;
  created_by_user_id: number | null;
  created_at: string;
  submitted_at: string | null;
  completed_by_user_id: number | null;
  completed_at: string | null;
  notes: string | null;
  updated_at: string;
}

export interface CoscoOnhirePrefill {
  email: string;
  ticketType: string;
  equipmentService: string;
  region: string;
  location: string;
  containerNumber: string;
  descriptionHtml: string;
}

export interface CoscoOnhireStartResponse {
  requestId: number;
  url: string;
  prefill: CoscoOnhirePrefill;
}

export const coscoOnhireApi = {
  async start(taskId: number): Promise<CoscoOnhireStartResponse> {
    const response = await api.post('/cosco-onhire/start', { taskId });
    return response.data as CoscoOnhireStartResponse;
  },

  async listForTask(taskId: number): Promise<CoscoOnhireRequest[]> {
    const response = await api.get(`/cosco-onhire?taskId=${taskId}`);
    return response.data as CoscoOnhireRequest[];
  },

  async markCompleted(id: number, notes?: string): Promise<CoscoOnhireRequest> {
    const response = await api.put(`/cosco-onhire/${id}/complete`, { notes });
    return response.data as CoscoOnhireRequest;
  },

  async markAbandoned(id: number): Promise<CoscoOnhireRequest> {
    const response = await api.put(`/cosco-onhire/${id}/abandon`);
    return response.data as CoscoOnhireRequest;
  },
};

export default coscoOnhireApi;
